import {memo} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {useTranslation} from "react-i18next";

interface ForbiddenProps {
    isForbidden: boolean
}

const Forbidden = ({isForbidden}: ForbiddenProps) => {
    const {t} = useTranslation();
    if (!isForbidden)
        return <></>

    return <div className="my-8 text-center">
            <FontAwesomeIcon icon={solid('biohazard')} className="w-24 h-24 text-red-400"/>
            <h3 className="mt-4 uppercase text-[2rem] font-bold block">{t('admin.forbidden.title')}</h3>
            <h4 className="">{t('admin.forbidden.message')}</h4>
    </div>
}

export default memo(Forbidden);
